<template>
  <base-section
    id="work"
  >
    <!-- <v-img
      :src="require('@/assets/logo.svg')"
      class="mx-auto mb-8"
      max-width="128"
    /> -->

    <base-section-heading title="Ofertas de Empleo">
      Necesitamos personas capaces y dispuestas a crecer profesionalmente en ROSMAR.<br>
      Con cualificación técnica y/o de gestión, valoramos también la experiencia en otros sectores.<br>
      Participa en nuestros procesos de selección mediante este formulario y te contactaremos cuando abramos un proceso.
    </base-section-heading>

    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          v-for="(item, n) in items"
          :key="n"
          cols="12"
          md="3"
        >
          <base-hexagon-generator
            :img="item.image"
            :slug="item.slug"
            base-url="work-us"
          />
          <div class="text-center body-1 text-uppercase">
            {{ item.title }}
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  // Mixins
  import Works from '@/mixins/works'
  export default {
    name: 'SectionWorkUs',

    mixins: [
      Works,
    ],

    data: () => ({
      // imagen: require('@/assets/about.jpg'),
      /* itemsOld: [
        {
          image: 'works/solar.jpg',
          title: 'Oficial de energías renovables (H/M)',
          slug: 'oficial-renovables',
        },
        {
          image: 'works/electricidad_02.jpg',
          title: 'Oficial Electricidad (H/M)',
          slug: 'oficial-electricidad',
        },
      ], */
    }),

    /* computed: {
      items () {
        return this.$store.state.works
      },
    },

    methods: {
      checkWorks () {
        if (this.items.length) {
          return
        }
        this.$store.dispatch('getWorks')
      }
    },

    mounted () {
      this.checkWorks()
    }, */
  }
</script>
